import { render, staticRenderFns } from "./messaging-action.vue?vue&type=template&id=4a47eba7"
import script from "./messaging-action.vue?vue&type=script&lang=js"
export * from "./messaging-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports